import React from 'react';
import { FaLightbulb, FaMoon, FaThermometerHalf, FaBolt } from 'react-icons/fa';

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const assignments = [
  {
    label: 'Opening Check',
    icon: FaLightbulb,
    iconBg: 'bg-amber-500',
    iconColor: 'text-white',
    code: 'AH',
  },
  {
    label: 'Closing Check',
    icon: FaMoon,
    iconBg: 'bg-blue-500',
    iconColor: 'text-white',
    code: 'AM',
  },
  {
    label: 'PAT Inspection',
    icon: FaBolt,
    iconBg: 'bg-orange-500',
    iconColor: 'text-white',
    code: 'ZK',
  },
  {
    label: 'Temperature Log',
    icon: FaThermometerHalf,
    iconBg: 'bg-green-500',
    iconColor: 'text-white',
    code: 'OF',
  },
];

const codeStyles = {
  AH: 'bg-blue-100 text-blue-700 border-blue-200',
  AM: 'bg-rose-100 text-rose-700 border-rose-200',
  ZK: 'bg-amber-100 text-amber-700 border-amber-200',
  OF: 'bg-purple-100 text-purple-700 border-purple-200',
};

const WeeklyTable = () => {
  return (
    <section className="mt-6 overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse text-sm">
          <thead>
            <tr className="bg-slate-50 text-left text-xs font-bold uppercase tracking-[0.08em] text-slate-500">
              <th className="w-[260px] border-b border-slate-100 px-5 py-4">Check</th>
              {days.map((day) => (
                <th key={day} className="border-b border-slate-100 px-4 py-4 text-center">
                  {day}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {assignments.map((item, index) => {
              const Icon = item.icon;
              return (
                <tr key={item.label} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50/40'}>
                  <td className="border-b border-slate-100 px-5 py-4">
                    <div className="flex items-center gap-3">
                      <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${item.iconBg} ${item.iconColor}`}>
                        <Icon className="h-4 w-4" />
                      </div>
                      <div>
                        <p className="font-semibold text-slate-900">{item.label}</p>
                        <p className="text-xs text-slate-500">Code {item.code}</p>
                      </div>
                    </div>
                  </td>
                  {days.map((day) => (
                    <td key={`${item.label}-${day}`} className="border-b border-slate-100 px-4 py-4 text-center">
                      <div
                        className={`inline-flex h-9 min-w-12 items-center justify-center rounded-full border px-3 text-xs font-bold ${
                          codeStyles[item.code] || 'border-slate-200 bg-slate-100 text-slate-700'
                        }`}
                      >
                        {item.code}
                      </div>
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default WeeklyTable;
